import {
  AirplanemodeActive,
  Language,
  ShieldOutlined,
  Stars,
} from "@mui/icons-material";
import { Box, Divider, Stack, Typography } from "@mui/material";

export default function OnboardingLoginAndRegister() {
  return (
    <Box
      sx={{
        width: { xs: "0%", md: "50%" },
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url('/assets/icons/background.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(5,15,60,0.85) 0%, rgba(0,60,130,0.65) 40%, rgba(0,40,100,0.75) 100%)",
          backdropFilter: "blur(4px)",
        },
      }}
    >
      <Stack
        spacing={3}
        alignItems="center"
        sx={{
          position: "relative",
          zIndex: 2,
          p: 4,
          textAlign: "center",
          maxWidth: 420,
        }}
      >
        <img
          src="/assets/icons/logo.png"
          alt="Convisas Logo"
          style={{
            maxWidth: 250,
            width: 120,
            borderRadius: 24,
            boxShadow: "0 6px 24px rgba(255,255,255,0.15)",
            padding: 8,
            background: "rgba(255,255,255,0.05)",
          }}
          draggable={false}
        />
        <Typography
          variant="h4"
          fontWeight={800}
          color="#fff"
          sx={{
            textShadow: "0 3px 10px rgba(0,0,0,0.5)",
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          ¡Bienvenido!
        </Typography>

        <Typography
          variant="body1"
          color="rgba(255,255,255,0.85)"
          sx={{
            fontSize: "0.95rem",
            lineHeight: 1.6,
            textAlign: "center",
            mb: 2,
          }}
        >
          Estás a un paso de comenzar tu asesoría integral para tu Visa
          Americana. Disfruta de un proceso claro, acompañado y confiable para
          que aumentes tus probabilidades de visitar los Estados Unidos como
          turista.{" "}
        </Typography>

        <Divider
          sx={{
            width: "40%",
            borderColor: "rgba(255,255,255,0.2)",
            mb: 1,
          }}
        />

        <Stack
          direction="row"
          spacing={3}
          justifyContent="center"
          sx={{ mt: 1, color: "rgba(255,255,255,0.9)" }}
        >
          <Stack alignItems="center" spacing={0.5}>
            <ShieldOutlined sx={{ fontSize: 30, color: "#00C3FF" }} />
            <Typography variant="caption" color="rgba(255,255,255,0.8)">
              Seguro
            </Typography>
          </Stack>

          <Stack alignItems="center" spacing={0.5}>
            <AirplanemodeActive sx={{ fontSize: 30, color: "#FFD700" }} />
            <Typography variant="caption" color="rgba(255,255,255,0.8)">
              Global
            </Typography>
          </Stack>

          <Stack alignItems="center" spacing={0.5}>
            <Language sx={{ fontSize: 30, color: "#72F5A6" }} />
            <Typography variant="caption" color="rgba(255,255,255,0.8)">
              Conectado
            </Typography>
          </Stack>

          <Stack alignItems="center" spacing={0.5}>
            <Stars sx={{ fontSize: 30, color: "#F8B400" }} />
            <Typography variant="caption" color="rgba(255,255,255,0.8)">
              Premium
            </Typography>
          </Stack>
        </Stack>

        <Typography
          variant="body2"
          sx={{
            mt: 3,
            color: "rgba(255,255,255,0.6)",
            fontStyle: "italic",
            letterSpacing: 0.5,
          }}
        >
          “Tu viaje comienza aquí ✈️”
        </Typography>
      </Stack>
    </Box>
  );
}
